import { http } from '@/api/core/request';
import { ApiUrls } from '@/api/endpoints/apiUrls';
import {
  AddFriendParams,
  RemoveFriendParams,
  BlockFriendParams,
  UnblockFriendParams,
  ReportFriendParams,
  UpdateFriendParams,
  FriendListResult,
  SearchParams
} from '@/api/types';

/**
 * 好友服务
 * 处理好友相关的API请求
 */
export class FriendService {
  /**
   * 添加好友
   * @param params 添加好友参数
   * @returns 空响应
   */
  static async addFriend(params: AddFriendParams): Promise<void> {
    return http.post<void>(ApiUrls.FRIEND.ADD, params);
  }

  /**
   * 移除好友
   * @param params 移除好友参数
   * @returns 空响应
   */
  static async removeFriend(params: RemoveFriendParams): Promise<void> {
    return http.post<void>(ApiUrls.FRIEND.REMOVE, params);
  }

  /**
   * 屏蔽用户
   * @param params 屏蔽用户参数
   * @returns 空响应
   */
  static async blockFriend(params: BlockFriendParams): Promise<void> {
    return http.post<void>(ApiUrls.FRIEND.BLOCK, params);
  }

  /**
   * 取消屏蔽用户
   * @param params 取消屏蔽参数
   * @returns 空响应
   */
  static async unblockFriend(params: UnblockFriendParams): Promise<void> {
    return http.post<void>(ApiUrls.FRIEND.UNBLOCK, params);
  }

  /**
   * 举报用户
   * @param params 举报参数
   * @returns 空响应
   */
  static async reportFriend(params: ReportFriendParams): Promise<void> {
    return http.post<void>(ApiUrls.FRIEND.REPORT, params);
  }

  /**
   * 更新好友信息
   * @param params 更新参数
   * @returns 空响应
   */
  static async updateFriend(params: UpdateFriendParams): Promise<void> {
    return http.post<void>(ApiUrls.FRIEND.UPDATE, params);
  }

  /**
   * 获取屏蔽列表
   * @returns 屏蔽列表
   */
  static async getBlockedList(): Promise<FriendListResult> {
    return http.get<FriendListResult>(ApiUrls.FRIEND.BLOCK_LIST);
  }

  /**
   * 获取好友列表
   * @param params 搜索参数
   * @returns 好友列表
   */
  static async getFriendList(params?: SearchParams): Promise<FriendListResult> {
    return http.get<FriendListResult>(ApiUrls.FRIEND.LIST, params);
  }
}
